var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.draggable)?_c('i',{staticClass:"widget__handle mdi mdi-cursor-move"}):_vm._e(),_vm._v(" "),_c('loader',_vm._b({},'loader',_vm.loader,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-526d3342","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/WidgetWrapper.vue
// module id = 719
// module chunks = 1